<ng-content></ng-content>

<ng-template #deleteConfirmationModal>
  <div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
  </div>
  <div class="modal-body" ngbAutofocus>{{ message }}</div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" (click)="dismiss()">Annuler</button>
    <button type="button" class="btn btn-blue" (click)="delete()">Supprimer</button>
  </div>
</ng-template>
